import type { ReactNode } from 'react'

type OffsetFrameProps = {
  as?: 'aside' | 'div'
  children: ReactNode
  className?: string
  variant: 'cta' | 'hero' | 'notice' | 'quote'
}

const frameClasses = {
  hero: {
    topLeft: '-left-[14px] -top-[18px] h-[280px] w-[370px] border-l-[4px] border-t-[4px]',
    right: '-right-[15px] top-[29px] h-[326px] w-[4px] bg-[#131a54]',
    bottom: '-bottom-[13px] left-[24px] h-[4px] w-[370px] bg-[#131a54]',
  },
  quote: {
    topLeft: '-left-[16px] -top-[17px] h-[247px] w-[383px] border-l-[4px] border-t-[4px]',
    right: '-right-[13px] top-[20px] h-[calc(100%-10px)] w-[4px] bg-[#131a54]',
    bottom: '-bottom-[14px] left-[10px] h-[4px] w-[calc(100%+12px)] bg-[#131a54]',
  },
  notice: {
    topLeft: '-left-[12px] -top-[15px] h-[calc(100%+10px)] w-[calc(100%+2px)] border-l-[4px] border-t-[4px] min-[900px]:h-[246px] min-[900px]:w-[286px]',
    right: '-right-[12px] top-[20px] h-[calc(100%-10px)] w-[4px] bg-[#131a54] min-[900px]:h-[225px]',
    bottom: '-bottom-[15px] left-[10px] h-[4px] w-[calc(100%+2px)] bg-[#131a54] min-[900px]:w-[286px]',
  },
  cta: {
    topLeft: '-left-[13px] -top-[15px] h-[100px] w-[calc(100%+26px)] border-l-[4px] border-t-[4px]',
    right: '-right-[12px] top-[14px] h-[90px] w-[4px] bg-[#131a54]',
    bottom: '-bottom-[14px] left-[10px] h-[4px] w-[calc(100%+12px)] bg-[#131a54]',
  },
} as const

export default function OffsetFrame({ as: Component = 'div', children, className = '', variant }: OffsetFrameProps) {
  const frame = frameClasses[variant]

  return (
    <Component className={`relative border-[4px] border-[#b74736] ${className}`.trim()}>
      <span aria-hidden="true" className={`absolute border-[#131a54] ${frame.topLeft}`} />
      <span aria-hidden="true" className={`absolute ${frame.right}`} />
      <span aria-hidden="true" className={`absolute ${frame.bottom}`} />
      {children}
    </Component>
  )
}
